import React from 'react';
import {
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Spinner
} from 'reactstrap';
// import Legend from '../components/Legend';
import PropTypes from 'prop-types';
import Http from '../Http'
import { connect } from 'react-redux';
import { Line } from 'react-chartjs-2';
import { FormatNumberInEur, CalcDeltaTable, FormatNumberInPerc } from './Utils'

class ChartDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showChart: true,
      showMoreInfo: false, //info from coefficienti e indici
      showMoreInfoSingle: false, //info from statistiche cliente
      clientsDataYears: [],
      filters: {
        max_result: 1000,
        from: this.props.user.reports.newestReportYear - 4,
        to: this.props.user.reports.newestReportYear,
        indexName: this.props.chartOptions.indexName,
        clientsId: []
      }
    }
    this.api = '/api/v1';

    this.toggleMoreInfo = this.toggleMoreInfo.bind(this)
    this.toggleMoreInfoSingle = this.toggleMoreInfoSingle.bind(this)

  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    // Chart.plugins.register(ChartDataAnnotations);
    // Chart.plugins.register(ChartDataLabels);
    let clientsId = []
    await this.props.clientsData.map((client) => {
      clientsId.push(client.id)
    })

    let { filters } = this.state
    //update the filters
    filters["clientsId"] = clientsId
    this.setState({
      filters
    })
    this.getData()
  }

  getData(newFilters) {
    let { filters } = this.state
    if (newFilters) {
      //update the filters
      filters[Object.keys(newFilters)] = newFilters[Object.keys(newFilters)]
      this.setState({
        filters,
        loading: true
      })
    }
    const data = new FormData()
    data.append('filters', JSON.stringify(filters))

    Http.post(`${this.api}/clients-with-filters`, data, {}
    ).then(res => {
      this.setState({
        loading: false,
        clientsDataYears: res.data.data
      })

    }).catch((e) => {
      // alert('Si è verificato un errore.')
      console.warn(e)
      this.setState({
        loading: false
      });
    });
  }

  toggleMoreInfoSingle() { //from statistiche cliente
    window.scrollTo(0, 0);
    this.getData(null)
    if (this.state.showChart) {
      this.setState({
        loading: true,
        showChart: false,
        showMoreInfoSingle: true
      })
    } else {
      this.setState({
        showChart: true,
        showMoreInfoSingle: false
      })
    }
  }

  toggleMoreInfo() { //from coefficienti e indici
    window.scrollTo(0, 0);
    if (this.state.showChart) {
      this.setState({
        showChart: false,
        showMoreInfo: true
      })
    } else {
      this.setState({
        showChart: true,
        showMoreInfo: false
      })
    }
  }

  render() {
    let { loading, showChart, showMoreInfo, showMoreInfoSingle, clientsDataYears, filters } = this.state
    let { chartOptions, chartData, title, description, user } = this.props
    let { newestReportYear } = user.reports
    let fatturatoClassName = chartOptions.indexName == "fatturato_bilancio" ? "bg-dark" : ""
    let cpfClassName = chartOptions.indexName == "cpf" ? "bg-dark" : ""
    let ccmClassName = chartOptions.indexName == "ccm" ? "bg-dark" : ""
    let ccbClassName = chartOptions.indexName == "ccb" ? "bg-dark" : ""
    let ratingClassName = chartOptions.indexName == "punteggio_my_client" ? "bg-dark" : ""
    let boostClassName = chartOptions.indexName == "boost" ? "bg-dark" : ""
    let deltaIndexName = "delta_" + chartOptions.indexName;
    switch (chartOptions.indexName) {
      case 'mol':
        deltaIndexName = 'delta_mol_ap'
        break;
      case 'indebitamento':
        deltaIndexName = 'delta_indebitamento_ap'
        break;
    }
    return (
      <>

        <Row>
          <Col md="12">
            <Card>
              <h3 className="text-left m-3 mb-0">{title}</h3>
              <p className="text-left ml-3 mb-3">{description}</p>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="12">

            {showChart &&
              <Card>
                <CardBody>
                  <Line data={chartData} height={100} width={null} options={chartOptions} />
                </CardBody>
              </Card>
            }
            {showMoreInfo &&
              <Card>
                <CardBody>
                  <Row>
                    <Col md="6">
                    </Col>
                    <Col md="6">
                      <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => { this.getData({ from: this.state.filters.to }) }}>Ultimo anno</Button>
                      <Button className="animation-on-hover float-right text-center ml-3" color="secondary" size="sm" onClick={() => { this.getData({ from: this.state.filters.to - 2 }) }}>Ultimi 3 anni</Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            }
          </Col>
        </Row >

        <Row>
          <Col md="12">
            {showChart &&
              <Card>
                <h3 className="text-left m-3 mb-0">Tabella</h3>
                <CardBody>
                  <Table>
                    <thead>
                      <tr>
                        <th>{chartOptions.indexName == "boost" ? "Componenti" : "Competitor"}</th>
                        {this.props.chartData.labels.map((label) => {
                          return (<th key={label}>{label}</th>)
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {chartData.datasets.map((dataset) => {
                        //se ha tooltip sono delta quindi usare percentuale
                        if (chartOptions.tooltips) {
                          return (
                            <tr key={dataset.label}>
                              <td scope="row" className="client-legend-col"><p className="client-legend" style={{ backgroundColor: dataset.borderColor }}></p> <p className="client-legend-name">{dataset.label}</p></td>
                              {dataset.data.map((value, i) => {
                                if (i < this.props.chartData.labels.length) {
                                  return (<td><p>{FormatNumberInPerc(value)}</p></td>)
                                }
                              })}
                            </tr>
                          )
                        } else {
                          return (
                            <tr key={dataset.label}>
                              <td scope="row" className="client-legend-col"><p className="client-legend" style={{ backgroundColor: dataset.borderColor }}></p> <p className="client-legend-name">{dataset.label}</p></td>
                              <td><p>{dataset.data[0]}</p></td>
                              <td><p>{dataset.data[1]}</p></td>
                              <td><p>{dataset.data[2]}</p></td>
                              <td><p>{dataset.data[3]}</p></td>
                              <td><p>{dataset.data[4]}</p></td>
                            </tr>
                          )
                        }
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            }
            {(showMoreInfo && loading || showMoreInfoSingle && loading) &&
              <div className="content text-center">
                <Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
              </div>
            }
            {showMoreInfoSingle && !loading &&
              <Card>
                <h3 className="text-left m-3 mb-0">Tabella {chartData.datasets[0].label}</h3>
                <CardBody>
                  <Table>
                    <thead>
                      <tr key="head">
                        <th>{chartOptions.indexName == "boost" ? "Componenti" : "Competitor"}</th>
                        {chartData.labels.map((label) => {
                          return (<th >{label}</th>)
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {chartOptions.tooltips ? (
                        <>
                          <tr key={chartOptions.indexName}>
                            <td scope="row">{title} (€)</td>
                            {clientsDataYears[filters.from].length > 0 && (<td>{FormatNumberInEur(clientsDataYears[filters.from][0][chartOptions.indexName], false, true)}</td>)}
                            <td>{FormatNumberInEur(clientsDataYears[filters.from + 1][0][chartOptions.indexName], false, true)}</td>
                            <td>{FormatNumberInEur(clientsDataYears[filters.from + 2][0][chartOptions.indexName], false, true)}</td>
                            <td>{FormatNumberInEur(clientsDataYears[filters.from + 3][0][chartOptions.indexName], false, true)}</td>
                            <td>{FormatNumberInEur(clientsDataYears[filters.from + 4][0][chartOptions.indexName], false, true)}</td>
                          </tr>
                          <tr key={deltaIndexName}>
                            <td scope="row">Delta {title}</td>
                            {clientsDataYears[filters.from].length > 0 && (<td>{clientsDataYears[filters.from][0][deltaIndexName] > 0 ? "+" + clientsDataYears[filters.from][0][deltaIndexName] + "%" : clientsDataYears[filters.from][0][deltaIndexName] + "%"}</td>)}
                            <td>{clientsDataYears[filters.from + 1][0][deltaIndexName] > 0 ? "+" + clientsDataYears[filters.from + 1][0][deltaIndexName] + "%" : clientsDataYears[filters.from + 1][0][deltaIndexName] + "%"}</td>
                            <td>{clientsDataYears[filters.from + 2][0][deltaIndexName] > 0 ? "+" + clientsDataYears[filters.from + 2][0][deltaIndexName] + "%" : clientsDataYears[filters.from + 2][0][deltaIndexName] + "%"}</td>
                            <td>{clientsDataYears[filters.from + 3][0][deltaIndexName] > 0 ? "+" + clientsDataYears[filters.from + 3][0][deltaIndexName] + "%" : clientsDataYears[filters.from + 3][0][deltaIndexName] + "%"}</td>
                            <td>{clientsDataYears[filters.from + 4][0][deltaIndexName] > 0 ? "+" + clientsDataYears[filters.from + 4][0][deltaIndexName] + "%" : clientsDataYears[filters.from + 4][0][deltaIndexName] + "%"}</td>
                          </tr>
                        </>
                      ) : (<tr key={chartOptions.indexName}>
                        <td scope="row">{title}</td>
                        {clientsDataYears[filters.from].length > 0 && (<td>{clientsDataYears[filters.from][0][chartOptions.indexName]}</td>)}
                        <td>{clientsDataYears[filters.from + 1][0][chartOptions.indexName]}</td>
                        <td>{clientsDataYears[filters.from + 2][0][chartOptions.indexName]}</td>
                        <td>{clientsDataYears[filters.from + 3][0][chartOptions.indexName]}</td>
                        <td>{clientsDataYears[filters.from + 4][0][chartOptions.indexName]}</td>
                      </tr>
                      )}
                    </tbody>

                  </Table>
                </CardBody>
              </Card>
            }
            {(showMoreInfo && !loading) &&
              Object.keys(clientsDataYears).reverse().map((keyName, i) => {
                return (
                  <Card>
                    <CardBody>
                      <h3 className="text-left m-3 mb-0">Anno {keyName}</h3>
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Pos.</th>
                            <th>Competitor</th>
                            <th>Fatturato Competitor (€)</th>
                            <th>Delta Fatt. Competitor</th>
                            <th>CPF</th>
                            <th>CCM</th>
                            <th>CCF</th>
                            <th>EXP</th>
                            <th>Rating</th>
                          </tr>
                        </thead>
                        <tbody>
                          {clientsDataYears[keyName].map((clientsDataYear, j) => {
                            let rowClass = clientsDataYear.highlighted ? "table-primary" : ""
                            return (
                              <tr className={rowClass} key={clientsDataYear.id + clientsDataYear.year}>
                                <td>{clientsDataYear.position}</td>
                                <td scope="row">{clientsDataYear.name}</td>
                                <td className={fatturatoClassName}>{FormatNumberInEur(clientsDataYear.fatturato_bilancio, false, true)}</td>
                                <td>{clientsDataYear.delta_fatturato_bilancio ? clientsDataYear.delta_fatturato_bilancio + "%" : "-"}</td>
                                <td className={cpfClassName}>{clientsDataYear.cpf}</td>
                                <td className={ccmClassName}>{clientsDataYear.ccm}</td>
                                <td className={ccbClassName}>{clientsDataYear.ccb}</td>
                                <td>{clientsDataYear.exp == null ? "-" : clientsDataYear.exp}</td>
                                <td className={ratingClassName}>{clientsDataYear.punteggio_my_client_testo}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                )
              })
            }

          </Col>
        </Row>
        <Row>
          <Col md="12">
            <div className="clearfix mt-5">
              <Button className="animation-on-hover float-right text-center ml-3" color="secondary" onClick={this.props.toggleChartDetails}>Torna indietro</Button>
              {!showMoreInfo && filters.clientsId.length > 1 &&
                <Button className="animation-on-hover float-right text-center ml-3" color="primary" onClick={this.toggleMoreInfo}>Approfondisci</Button>
              }
              {!showMoreInfoSingle && filters.clientsId.length == 1 &&
                <Button className="animation-on-hover float-right text-center ml-3" color="primary" onClick={this.toggleMoreInfoSingle}>Approfondisci</Button>
              }
            </div>
          </Col>
        </Row >
      </>
    )
  }

}


ChartDetails.propTypes = {
  toggleChartDetails: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(ChartDetails);